<script setup lang="ts">
    /**
     * 📘docs: https://onewoom.atlassian.net/wiki/spaces/ECOM/pages/147357759
     */
    const props = defineProps<IWidgetProps<LookbookHighlightData>>();
    const { cmsComponentProps } = useWidget(props);
</script>
<template>
    <mol-lookbook-slide v-bind="cmsComponentProps" />
</template>
